import { NotFound } from "@/frontend/pages/NotFound";
import { useFusaOrganizationStore } from "@/frontend/store/FusaOrganizationStore";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { useProjectLockStore } from "@/frontend/store/ProjectLockStore";
import { useProjectStore } from "@/frontend/store/ProjectStore";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";
import { TwoPanelPlaceholder } from "../TwoPanelPlaceholder";
import { ProjectLocked } from "./ProjectLocked";
import { ProjectLayout } from "./ProjectLayout";

export function ProjectPageLoader(props: { children: React.ReactNode }) {
  const { children } = props;
  const projectId = useParams().projectId;

  const fetchProject = useProjectStore(state => state.fetchProject);
  const fetchFusaOrganizationsByEnterpriseId = useFusaOrganizationStore(state => state.fetchFusaOrganizationsByEnterpriseId);
  const resetProjectStore = useProjectStore(state => state.reset);

  const enterprise = useGlobalStore(state => state.enterprise);
  const project = useProjectStore(useShallow(state => state.projects.find(project => project.id === projectId)));
  const projectLock = useProjectLockStore(useShallow(state => state.projectLocks.find(projectLock => projectLock.projectId === projectId)));

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(projectId) {
      setLoading(true);
      void fetchProject(projectId).finally(() => {
        setLoading(false);
      });
    }

    return () => {
      resetProjectStore();
    };
  }, [projectId, fetchProject, resetProjectStore]);

  useEffect(() => {
    if (enterprise?.id) {
      void fetchFusaOrganizationsByEnterpriseId(enterprise.id);
    }
  }, [enterprise, fetchFusaOrganizationsByEnterpriseId]);

  if(!projectId) {
    return <NotFound />;
  }

  if(loading) {
    return <TwoPanelPlaceholder />;
  }

  if(projectLock?.isLocked()) {
    return <ProjectLocked />;
  }

  if(!project) {
    return <NotFound />;
  }

  return (
    <ProjectLayout projectId={projectId}>
      {children}
    </ProjectLayout>
  );
}
